import React, { useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ProductInfo from './ProductInfo';
import Recipes from './Recipes';

const AppUserHome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { productId, recipeId } = useParams();

  const pathToTabIndex = {
    'encyklopedia': 0,
    'przepisy': 1,
  };

  const tabIndexToPath = ['/encyklopedia', '/przepisy'];

  const currentTab = pathToTabIndex[location.pathname.split('/')[1]] ?? 0;

  const handleTabChange = (event, newValue) => {
    navigate(tabIndexToPath[newValue]);
  };

  const handleTabClick = (event, newValue) => {
    navigate(tabIndexToPath[newValue]);
  };

  useEffect(() => {
    const pathSection = location.pathname.split('/')[1];
    if (!Object.keys(pathToTabIndex).includes(pathSection)) {
      navigate('/encyklopedia');
    }
  }, [location.pathname, navigate]);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        centered
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Encyklopedia" onClick={(event) => handleTabClick(event, 0)} />
        <Tab label="Przepisy" onClick={(event) => handleTabClick(event, 1)} />
      </Tabs>

      <Box>
        {currentTab === 0 && (
          <ProductInfo productId={productId} />
        )}
        {currentTab === 1 && (
          <Recipes recipeId={recipeId} />
        )}
      </Box>
    </Box>
  );
};

export default AppUserHome;